import React from "react";
import { AlertTriangle } from "lucide-react";
import Modal from "../common/Modal";

interface ConfirmDisconnectModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  integration: string;
}

const ConfirmDisconnectModal: React.FC<ConfirmDisconnectModalProps> = ({
  open,
  onClose,
  onConfirm,
  integration,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-3 bg-red-500/10 rounded-full">
            <AlertTriangle className="w-6 h-6 text-red-500" />
          </div>
          <h3 className="text-lg font-semibold">
            Disconnect{" "}
            {integration.charAt(0).toUpperCase() + integration.slice(1)}
          </h3>
        </div>
        <p className="text-text-secondary dark:text-text-secondaryDark mb-6">
          Are you sure you want to disconnect {integration}? This will revoke
          all access and you'll need to reconnect to use {integration} features
          again.
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium rounded-lg hover:bg-background-panel dark:hover:bg-background-panelDark transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
          >
            Disconnect
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDisconnectModal;
